import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMetricsFire = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 48 48",
	...props,
	children: /* @__PURE__ */ _jsx("switch", { children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("path", { d: "M38.849 9.151 24 3 9.151 9.151 3 24l6.151 14.85L24 45l14.849-6.15L45 24zm0 29.698L24 27.287 9.151 38.849 20.713 24 9.151 9.151 24 20.714 38.849 9.151 27.287 24z" }) }) })
});
export default SvgMetricsFire;
